Deletes a candidate process history item from SEEK's systems.
